import { Component, OnInit, Input } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as colabInter from '../bd-colaboradores.interface';
import * as backInter from 'app/auth/auth-data.model';
import { saveAs } from 'file-saver';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';


import { ColaboradoresService } from 'app/main/wizard-cgo/services/colaboradores.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';

@Component({
  selector: 'app-bd-colaboradores',
  templateUrl: './bd-colaboradores.component.html',
  styleUrls: ['./bd-colaboradores.component.scss'],
  animations   : fuseAnimations
})
export class BdColaboradoresComponent implements OnInit {
  @Input() productoID: any;
  @Input() fechaProducto:any;
  @Input() empresaId:any;
  moment = require('moment');
  colabsEnBD:any;
  fechaCarga:any;
  cargando:boolean=true;
  idiomaActual:any;
  columnasObligatorias:any
  instituto:any;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private colaboradoresService: ColaboradoresService,
    private wizardService: WizardService,
  ) {
    lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
          });
    lang_modales.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
          });

          //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
          this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    console.log(this.fechaProducto);
    this.getColaboradoresFast();
    this.obtieneInstituto();

  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_CAYC; break;
      case '3': case 'HK': this.instituto = 'HK'; this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_HK; break;
      case '4': case 'SGP': this.instituto = 'WLDWDE'; break;
      case '5': case 'TK': this.instituto = 'TK'; this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_TK; break;
      case '6': case 'FL': this.instituto = 'WLDWDE'; break;
      default: this.instituto = 'WLDWDE';
    }
    //se coloca aqui porque dentro de esa funcion se requiere tener el instituto
    this.traduceTextosTS();
  }

  descargaExcel(){
    Swal.fire({
      title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXCEL'),
      didOpen: () => {
        Swal.showLoading()
      }
    });
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.TITULO'),
      Subject: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.ASUNTO'),
      Author: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.AUTOR'),
      CreatedDate: new Date()
    };

    wb.SheetNames.push(this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.HOJA'));
    // var ws_data = [['hello' , 'world']];  //a row with 2 columns
    var ws_data = [];
    var columnaVacia=[];
    let nombresColumnas:string[] = [];

    // colabInter.CLAVES_COLUMNAS.forEach( (nombre) =>{
    //   nombresColumnas.push(nombre);
    // });
    // ws_data.push(nombresColumnas);

    this.colaboradoresService.getColaboradoresActualizarFull(this.fechaProducto, this.productoID, this.empresaId).subscribe( (getFull: colabInter.getBDFull) => {
      if(getFull.message == 'Success' && getFull.bdcolaboradores.length > 0){
        colabInter.CLAVES_COLUMNAS.forEach( (nombre,i) =>{
          // nombresColumnas.push(nombre);

          if(getFull.columnas[nombre.clave]){
            nombresColumnas.push(getFull.columnas[nombre.clave]);
          }
          else{
            columnaVacia.push(i);
          }
        });
        // console.log(nombresColumnas);
        ws_data.push(nombresColumnas);

        getFull.bdcolaboradores.forEach( (colaborador) => {
          let datosColaboradores:any[] = [];
          colabInter.CLAVES_COLUMNAS.forEach( (nombre,i) => {

            if(!columnaVacia.includes(i)){
              if(colaborador[nombre.clave]){
                switch (colaborador[nombre.clave]) {
                  case 'antiquity': case 'enterDate':
                    datosColaboradores.push(this.fechaCorrecta(colaborador[nombre.clave]));
                  break;
                  default:
                    datosColaboradores.push(colaborador[nombre.clave].toString());
                  break;
                }
              }
              else{
                if(nombre.clave == 'bossKey'){
                  datosColaboradores.push('0');
                }
                else{
                  datosColaboradores.push('');
                }
              }
            }
          });
          // console.log(datosColaboradores);
          ws_data.push(datosColaboradores);
        });

        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.HOJA')] = ws;

        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

        var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

        saveAs(new Blob([buf],{type:"application/octet-stream"}), this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.TITULO')+' - '+'BD_ACTUAL'+'.xlsx');
        Swal.close();
      }
    });
  }

  fechaCorrecta(fechaActual:any){
    let fechaFinal: string;
    if(isNaN(fechaActual)){
      fechaFinal = fechaActual;
    }
    else{
      let fechaInicial = "30-12-1899";
      let fechaReal = this.moment(fechaInicial, "DD-MM-YYYY");
      fechaReal.add(fechaActual, 'days');
      fechaFinal = this.moment(fechaReal).format('DD/MM/YYYY');
    }
    return fechaFinal;
  }

  getColaboradoresFast(){
    this.colaboradoresService.getActualizarColaboradoresFast(this.fechaProducto, this.productoID, this.empresaId)
    .subscribe( (getFast: colabInter.getBDFast) => {
      if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
        this.colabsEnBD = getFast.numeroColaboradores;
        this.fechaCarga = getFast.fecha;
        console.log("Perro");
        console.log(this.fechaCarga);
      }
      this.cargando = false;
    });
  }

  traduceTextosTS(){
    switch(this.translateSrv.currentLang){
      case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
      case 'zh1': case 'zh2':
        if(this.instituto == 'HK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      case 'tr':
        if(this.instituto == 'TK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      default: this.idiomaActual = 'en';
    }
  }



}
